<template>
    <div>
        <div>
            <el-button @click="displayvisible=true">增加条件表达式</el-button>
        </div>
        <shade v-if="displayvisible">
            <div class="shade-chil">
                <newcontainer @out='out'></newcontainer>
            </div>
        </shade>
    </div>
</template>
<script>
import shade from "@/components/shade/shade";
import newcontainer from "@/pages/test/newcontainer";
export default {
    name:'container',
    components: {
    shade,
    newcontainer
  },
  data(){
      return{
          displayvisible:false
      }
  },
  mounted() {
    // var shade=document.querySelector('.shade')
    // shade.style.zIndex='2000'
    // var center=shade.querySelector('.center')
    // center.style.zIndex='1999'
  },
  destroyed(){
    // var shade=document.querySelector('.shade')
    // shade.style.zIndex='5999'
    // var center=shade.querySelector('.center')
    // center.style.zIndex='3000'
  },methods:{
      out(){
          this.displayvisible=false
      }
  }
}
</script>
<style  scoped>
.shade-chil {
  width: 1070px;
  height: 680px;
  /* background-color: RGB(249,249,249); */
  border-radius: 12px;
  box-shadow: 4px 4px 12px #888888;
  background-image: linear-gradient(#f9f9f9, #fdfdfd, #f0f0f0, #f3f3f3);

  border-left: 1px solid #bbb;
  border-top: 1px solid #bbb;
  border-right: 1px solid #888;
  border-bottom: 1px solid #888;
  padding: 20px;
  position: relative;
  z-index: 100;
  -moz-user-select: none;
  -o-user-select: none;
  -khtml-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
    }
</style>


// WEBPACK FOOTER //
// src/pages/test/container.vue